import React from 'react';
import IobItem from '../../../Domain/IobItem';
import ShowEntityData from '../../../Elements/ShowEntityData';
import IobService from '../../../Services/IobService';

export default class IobDetailsInfoTab extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);

    this.state = {
      iobId: urlParams.get('id'),
      loading: true,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <ShowEntityData
        itemId={this.state.iobId}
        entityName='IOB Details'
        type={IobItem}
        serviceGetByIdFunction={IobService.GetById}
        showHead={false}
      />
    );
  }
}
